import { render, staticRenderFns } from "./GroupQuestionsFileDialog.vue?vue&type=template&id=6839bc2a&scoped=true"
import script from "./GroupQuestionsFileDialog.vue?vue&type=script&lang=js"
export * from "./GroupQuestionsFileDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupQuestionsFileDialog.vue?vue&type=style&index=0&id=6839bc2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6839bc2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsSearchIcon: require('/opt/atlassian/pipelines/agent/build/components/icons/SearchIcon.vue').default,IconsLicenseIcon: require('/opt/atlassian/pipelines/agent/build/components/icons/LicenseIcon.vue').default})
